module.exports = __webpack_public_path__ + "img/morntoproimg.866d6301.svg";